export default "__VITE_ASSET__D3KwuYT5__"